export default "/images/vendor/flag-icon-css/flags/1x1/cy.svg?bdc1fde27ba14b2afa3b59bec603759f";